export default __webpack_public_path__ + "static/media/Cold.2f3d5d57.mp3";